import { CalendarType } from 'components/CruiseSearchWidget/types';
import styles from './Year.css';

import { useFiltersContext } from 'components/FiltersProvider/FiltersProvider';
import { PillButton } from 'components/buttons/PillButton/PillButton';
import { DateRangeFilterMonth } from 'lib/apiClient';

interface YearProps {
	code: string;
	label: string;
	months: Array<DateRangeFilterMonth>;
}

const Year = ({ code, label, months }: YearProps) => {
	const { updateSelection, activeFilter, datesRangeSel, setDatesRangeSel } = useFiltersContext();

	const handleMonthClick = (dateRange: string) => {
		if (!activeFilter) return;
		updateSelection(activeFilter.key, { value: [dateRange], year: code, calendarType: CalendarType.Months });
		if (datesRangeSel) setDatesRangeSel([]);
	};

	return (
		<div className={styles.root}>
			<div className={styles.title}>{label}</div>
			<div className={styles.months}>
				{months.map((month) => (
					<PillButton
						testId="month-pill-button"
						label={month.label}
						key={month.code}
						isSelected={month.isSelected}
						isDisabled={month.isDisabled}
						onClick={() => handleMonthClick(month.dateRange)}
						customClass={styles.eachMonth}
					/>
				))}
			</div>
		</div>
	);
};

export { Year };
